import React, { useState } from 'react'

import { Button, Modal, ModalInjectedProps } from '@sketch/components'
import { useGetSocialSignIn } from '@sketch/modules-common'
import { GetSocialAuthStartUrlMutationVariables } from '@sketch/gql-types'

interface AreYouSureModalProps extends ModalInjectedProps {
  provider: GetSocialAuthStartUrlMutationVariables['provider']
}

/**
 * Confirmation modal displayed when a user is about to delete their account.
 * Provides a final warning before proceeding with the irreversible action.
 */
const AreYouSureModal = ({ hideModal, provider }: AreYouSureModalProps) => {
  const [isPersistentLoading, setIsPersistentLoading] = useState(false)

  const { getSocialAuthStartUrl, loadingState } = useGetSocialSignIn()

  const handleDeleteAccount = () => {
    setIsPersistentLoading(true)

    getSocialAuthStartUrl({
      variables: {
        provider,
        action: 'DELETE_ACCOUNT',
      },
    })
  }

  const loading = isPersistentLoading || loadingState.isLoading

  return (
    <Modal title="Are you sure?" onCancel={hideModal}>
      <Modal.Body>
        <p>
          Deleting your account is a permanent action. Once you delete your
          account, this cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Cancel
        </Button>
        <Button
          variant="negative"
          onClick={handleDeleteAccount}
          loading={loading}
        >
          Delete Account
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AreYouSureModal
